export const PackageApiEndpoint = {
  fetchPackageList: '/package', // GET: 패키지 리스트조회
  fetchPackageCalenderList: '/room-calender/package', // GET: 패키지 리스트조회
  fetchPackageAmount: '/package/amounts',
  requestPackage: '/package', // POST 패키지 예약
  fetchPackageReservationList: '/package/reservations', // GET: 패키지 예약한 정보 조회
  fetchPackageReservationDetail: '/package/reservation', // GET: 패키지 예약한 정보 상세조회,
  cancelPackageReservation: '/package/cancel/:resveNo', // PUT: 패키지 예약취소
};
